/* tslint:disable */
/* eslint-disable */
export enum ProjectBonusSettingDefaultValueType {
  Has = 1,
  HasNot = 2,
  Automatic = 3,
  Unset = 4,
  Workday_1_9 = 5,
  Workday_10_14 = 6,
  Workday_15_more = 7
}